/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-navigation-arrow-up-left': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M13.75 3.75V5H5.881L16.25 15.369l-.881.881L5 5.881v7.869H3.75v-10z"/>'
  }
})
